export const CONFIRMATION_POLICY = {
    deposit: "deposit",
    prePaid: "pre_paid",
    creditCardGuarantee: "credit_card_guarantee",
    none: "none"
}

export const CANCELLATION_POLICY = {
    notRefundable: "not_refundable",
    timeRestrictedRefundable: "time_restricted_refundable",
    totallyRefundable: "totally_refundable",
    none: "none"
}

export const PAYMENT_POLICY = {
    online: "online",
    hostCustomized: "host_customized"
}

export const EMAIL_MESSAGE_STATUS = {
    pending: "pending",
    completed: "completed",
    failed: "failed"
}

export const TOURIST_TAX_POLICY = {
    none: "none",
    included: "included",
    excluded: "excluded"
}